// apps/web/src/features/crm/leads/card/LeadCardManageActions.tsx
//
// Capability-gated lead assignment on the rich card. The retired Claim path
// is deliberately absent: eligibility and ownership conflicts are decided by
// the assignment endpoint, and every backend rejection is surfaced by the
// shared control.
import { LeadAssignmentControl } from '../components/LeadAssignmentControl.js';

export interface LeadCardManageActionsProps {
  leadId: string;
  canAssign: boolean;
}

export function LeadCardManageActions({ leadId, canAssign }: LeadCardManageActionsProps) {
  if (!canAssign) return null;
  return (
    <section
      data-testid="lead-card-manage-actions"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        padding: 16,
        border: '1px solid var(--border-1)',
        borderRadius: 'var(--r-2)',
        background: 'var(--bg-1)',
      }}
    >
      <LeadAssignmentControl leadId={leadId} />
    </section>
  );
}
